// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The following are the original styles for the ProjectsCard section.  */
.project-card__rail {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding: 0;
  margin: 0;
  list-style: none;
  scroll-snap-type: x proximity;
}
.project-card__follow-button {
  width: auto;
  border-radius: var(--border-radius-md, 0.5rem);
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);  
  padding: 0.5rem 0.625rem; /* ~8px 10px, increased by ~2px in rem */
  color: var(--color-primary, #7C4DFF);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-md, 500);
  background: var(--white, #FFF);
  cursor: pointer;
}

.project-card__follow-button:hover {
  background: var(--lavender-400, #cbb9ff);
}

.project-card__rail::-webkit-scrollbar {
  height: 8px;
}

.project-card__rail::-webkit-scrollbar-thumb {
  background: #b0b7c3;
  border-radius: 999px;
}

.project-card {
  flex: 0 0 min(420px, 88vw);
  scroll-snap-align: start;
  border-radius: var(--border-radius-md, 0.5rem);
  border: var(--border-width-sm, 0.1rem) solid var(--gray-200, #E5E7EB);
  padding: var(--spacing-md, 1.25rem);
  justify-content: center;
  align-items: flex-start;
  gap: var(--spacing-sm, 0.938rem);
  flex-shrink: 0;
}

.project-card__link {
  display: block;
  color: inherit;
  text-decoration: none;
}

.project-card__link:hover .project-card__title,
.project-card__link:focus-visible .project-card__title {
  text-decoration: underline;
}

.project-card__wrapper {
  display: grid;
  grid-template-columns: 88px 1fr;
  gap: 0.9rem;
  align-items: start;
  padding-bottom: 0.563rem;
  border-radius: var(--border-radius-md, 0.5rem);
  border-bottom: 1px solid var(--gray-200, #E5E7EB);
}

.project-card__thumb {
  width: 66px;
  height: 66px;
  overflow: hidden;
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--gray-200, #E5E7EB);
  padding: 0.656rem var(--spacing-2xs, 0.625rem);
  aspect-ratio: 1/1;
}

.project-card__thumb-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.project-card__thumb-fallback {
  width: 100%;
  height: 100%;
  font-size: 0.72rem;
  color: #5a6476;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.project-card__content {
  min-width: 0;
}

.project-card__title,
.project-card__organization,
.project-card__category,
.project-card__meta,
.project-card__description {
  margin: 0;
}

.project-card__title {
  overflow: hidden;
  color: var(--gray-900, #101828);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-lg, 1.125rem);
  font-weight: var(--font-weight-bold, 600);
  align-self: stretch;
}

.project-card__organization {
  margin-top: 0.35rem;
  color: var(--gray-700, #364153);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  line-height: 1.35;
  max-height: calc(1.35em * 2);
  align-self: stretch;
}

.project-card__category {
  font-size: var(--font-size-xxs, 0.75rem);
  font-weight: var(--font-weight-md, 500);
}

.project-card__category--project {
  color: var(--purple-500, #AD46FF);
 
}

.project-card__category--community {
  color: var(--yellow-700, #A65F00);
}

.project-card__category--unknown {
  color: var(--slate-700, #314158);
}

.project-card__meta {
  margin-top: 0.55rem;
  overflow-wrap: anywhere;
  font-size: 0.86rem;
}

.project-card__footer {
  margin-top: 0.8rem;
  padding: 0.75rem;

}

.project-card__more-button {
  display: none;
}

@media (max-width: 640px) {
  .project-card__rail {
    flex-wrap: wrap;
    overflow-x: visible;
    scroll-snap-type: none;
  }

  .project-card {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .profile-section-collapsible[data-mobile-expanded="false"] .project-card:nth-child(n + 3) {
    display: none;
  }

  .project-card__more-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    margin-top: 0.75rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--color-primary, #7C4DFF);
    font-size: var(--font-size-sm, 0.875rem);
    font-weight: var(--font-weight-bold, 600);
    cursor: pointer;
  }

  .project-card__more-button[data-mobile-expanded="true"] .project-card__more-icon {
    transform: rotate(180deg);
  }

  .project-card__more-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform var(--animation-duration, 0.2s) ease;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/ProjectsCard.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,8CAA8C;EAC9C,0EAA0E;EAC1E,wBAAwB,EAAE,wCAAwC;EAClE,oCAAoC;EACpC,wCAAwC,EAAE,SAAS;EACnD,uCAAuC;EACvC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8CAA8C;EAC9C,qEAAqE;EACrE,mCAAmC;EACnC,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;EACnD,oCAAoC;EACpC,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;;AAEnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,oCAAoC;IACpC,wCAAwC;IACxC,yCAAyC;IACzC,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,0DAA0D;EAC5D;AACF","sourcesContent":["/* The following are the original styles for the ProjectsCard section.  */\n.project-card__rail {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  scroll-snap-type: x proximity;\n}\n.project-card__follow-button {\n  width: auto;\n  border-radius: var(--border-radius-md, 0.5rem);\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);  \n  padding: 0.5rem 0.625rem; /* ~8px 10px, increased by ~2px in rem */\n  color: var(--color-primary, #7C4DFF);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-md, 500);\n  background: var(--white, #FFF);\n  cursor: pointer;\n}\n\n.project-card__follow-button:hover {\n  background: var(--lavender-400, #cbb9ff);\n}\n\n.project-card__rail::-webkit-scrollbar {\n  height: 8px;\n}\n\n.project-card__rail::-webkit-scrollbar-thumb {\n  background: #b0b7c3;\n  border-radius: 999px;\n}\n\n.project-card {\n  flex: 0 0 min(420px, 88vw);\n  scroll-snap-align: start;\n  border-radius: var(--border-radius-md, 0.5rem);\n  border: var(--border-width-sm, 0.1rem) solid var(--gray-200, #E5E7EB);\n  padding: var(--spacing-md, 1.25rem);\n  justify-content: center;\n  align-items: flex-start;\n  gap: var(--spacing-sm, 0.938rem);\n  flex-shrink: 0;\n}\n\n.project-card__link {\n  display: block;\n  color: inherit;\n  text-decoration: none;\n}\n\n.project-card__link:hover .project-card__title,\n.project-card__link:focus-visible .project-card__title {\n  text-decoration: underline;\n}\n\n.project-card__wrapper {\n  display: grid;\n  grid-template-columns: 88px 1fr;\n  gap: 0.9rem;\n  align-items: start;\n  padding-bottom: 0.563rem;\n  border-radius: var(--border-radius-md, 0.5rem);\n  border-bottom: 1px solid var(--gray-200, #E5E7EB);\n}\n\n.project-card__thumb {\n  width: 66px;\n  height: 66px;\n  overflow: hidden;\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--gray-200, #E5E7EB);\n  padding: 0.656rem var(--spacing-2xs, 0.625rem);\n  aspect-ratio: 1/1;\n}\n\n.project-card__thumb-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.project-card__thumb-fallback {\n  width: 100%;\n  height: 100%;\n  font-size: 0.72rem;\n  color: #5a6476;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.project-card__content {\n  min-width: 0;\n}\n\n.project-card__title,\n.project-card__organization,\n.project-card__category,\n.project-card__meta,\n.project-card__description {\n  margin: 0;\n}\n\n.project-card__title {\n  overflow: hidden;\n  color: var(--gray-900, #101828);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--font-size-lg, 1.125rem);\n  font-weight: var(--font-weight-bold, 600);\n  align-self: stretch;\n}\n\n.project-card__organization {\n  margin-top: 0.35rem;\n  color: var(--gray-700, #364153);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  line-height: 1.35;\n  max-height: calc(1.35em * 2);\n  align-self: stretch;\n}\n\n.project-card__category {\n  font-size: var(--font-size-xxs, 0.75rem);\n  font-weight: var(--font-weight-md, 500);\n}\n\n.project-card__category--project {\n  color: var(--purple-500, #AD46FF);\n \n}\n\n.project-card__category--community {\n  color: var(--yellow-700, #A65F00);\n}\n\n.project-card__category--unknown {\n  color: var(--slate-700, #314158);\n}\n\n.project-card__meta {\n  margin-top: 0.55rem;\n  overflow-wrap: anywhere;\n  font-size: 0.86rem;\n}\n\n.project-card__footer {\n  margin-top: 0.8rem;\n  padding: 0.75rem;\n\n}\n\n.project-card__more-button {\n  display: none;\n}\n\n@media (max-width: 640px) {\n  .project-card__rail {\n    flex-wrap: wrap;\n    overflow-x: visible;\n    scroll-snap-type: none;\n  }\n\n  .project-card {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .profile-section-collapsible[data-mobile-expanded=\"false\"] .project-card:nth-child(n + 3) {\n    display: none;\n  }\n\n  .project-card__more-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.375rem;\n    width: 100%;\n    margin-top: 0.75rem;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: var(--color-primary, #7C4DFF);\n    font-size: var(--font-size-sm, 0.875rem);\n    font-weight: var(--font-weight-bold, 600);\n    cursor: pointer;\n  }\n\n  .project-card__more-button[data-mobile-expanded=\"true\"] .project-card__more-icon {\n    transform: rotate(180deg);\n  }\n\n  .project-card__more-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform var(--animation-duration, 0.2s) ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
